/**
 * The position component places entities at certain spots in 3D space.
 * Position takes a coordinate value as three space-delimited numbers.
 *
 * All entities inherently have the position component.
 *
 * @see https://aframe.io/docs/1.3.0/components/position.html
 */
export var Position = function Position(_ref) {
  var _this = this;

  var x = _ref.x,
      y = _ref.y,
      z = _ref.z;

  this.toString = function () {
    return _this.x + " " + _this.y + " " + _this.z;
  };

  this.x = x;
  this.y = y;
  this.z = z;
};